import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    ns: ['translation'],
    defaultNS: 'translation',
    fallbackNS: 'translation',
    lng: 'en',
    fallbackLng: 'en',
    debug: false, // process.env.NODE_ENV !== 'production',
    // detection: {
    //   // order and from where user language should be detected
    //   order: ['localStorage', 'htmlTag'],

    //   // optional htmlTag with lang attribute, the default is:
    //   htmlTag: document.documentElement,
    // },
    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false, // react already safes from xss
    }
  });

export default i18n;
